// removed by extract-text-webpack-plugin
module.exports = {"ArticleTags":"S0bWnMdXNML1METhHAFL2","IEWrapper":"_1MDMeAKjmiRr7JiCZKJ2AC","iconWrapper":"RUnxoxCOQ5-NYYSEhk86a","icon":"_16RejmYeK9yO_u-sR_H62H","tags":"_3U5nEp5043sT_MD2j6IiVf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ArticleTags/ArticleTags.module.scss
// module id = 732
// module chunks = 0